import React from 'react';
import DesignerComponent from './DesignerComponent';

function App() {
  return (
    <div>
      <DesignerComponent />
    </div>
  );
}

export default App;